import { LitElement, html,css } from "lit";
import { customElement } from "lit/decorators.js";
import '@awesome.me/webawesome/dist/styles/themes/default.css';
import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/split-panel/split-panel.js';

import { OutDesignHeader } from "./ui/HeaderElement";
import { OutDesignMainWindow } from "./ui/MainWindowElement";
import { OutDesignLeftSidebar } from "./ui/LeftSidebarElement";

OutDesignHeader;
OutDesignLeftSidebar;
OutDesignMainWindow;

console.log("Mode:", import.meta.env.MODE)

@customElement("od-app")
export class OutDesignApplicationElement extends LitElement {
  static styles = css`
  :host {
    font-family: sans-serif;
    height: 100vh;
    overflow: hidden;
    
    display: flex;
    flex-direction: column;
  }
  
  wa-split-panel {
    flex: 1;
    min-height: 0;
  }
  `
  
  render() {
    return html`
    <od-header></od-header>
    <wa-split-panel orientation="horizontal" primary="end" position="75" style="--max:80%; --min:60%">
      <od-left-sidebar slot="start"></od-left-sidebar>
      <od-main-window slot="end"></od-main-window>
    </wa-split-panel>
    `;
  }
}